import React from 'react';
import { ActivityIndicator } from '~/Partials/ActivityIndicator/ActivityIndicator';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { useFetchData } from '~/Partials/FetchData/useFetchData';
import { Link } from '~/Partials/Link/Link';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import { SvgIcon } from '~/Partials/SvgIcon/SvgIcon';
import styles from './SubjectOverlayAction.module.css';

export interface SubjectOverlayActionTranslations {
    errorMessage: string;
    buttonLabel: string;
    loadingMessage: string;
}

export interface SubjectOverlayActionProps {
    subjectCode: string;
    fetchSubjectLinkUrl: string;
    translations: SubjectOverlayActionTranslations;
    shouldMakeRequest: boolean;
}

export const SubjectOverlayAction: React.FC<SubjectOverlayActionProps> = props => {
    const { fetchSubjectLinkUrl, shouldMakeRequest, subjectCode, translations } = props;

    const { error, loading, data } = useFetchData<string>({
        url: fetchSubjectLinkUrl,
        params: {
            subjectCode,
        },
        shouldMakeRequest,
    });

    const renderControl = () => (
        <>
            <span>{translations.buttonLabel}</span>
            <SvgIcon iconName="arrow-right" />
        </>
    );

    const actionBaseConfig = (withButtonPrefix = false) => ({
        [withButtonPrefix ? 'buttonSize' : 'size']: ButtonSize.Large,
        [withButtonPrefix ? 'buttonTier' : 'tier']: ButtonTier.Primary,
        [withButtonPrefix ? 'buttonType' : 'type']: ButtonType.Solid,
        className: styles.Control,
    });

    return (
        <div className={styles.SubjectOverlayAction}>
            {loading && (
                <div className={styles.Spinner}>
                    <span className="visuallyHidden">{translations.loadingMessage}</span>
                    <ActivityIndicator modal={false} active />
                </div>
            )}
            {!data || error ? (
                <Button {...actionBaseConfig()} disabled>
                    {renderControl()}
                </Button>
            ) : (
                <Link {...actionBaseConfig(true)} type={LinkType.Button} href={data}>
                    {renderControl()}
                </Link>
            )}
            {error && <div className={styles.Error}>{translations.errorMessage}</div>}
        </div>
    );
};
